import React__default from 'react';
import styles from './230f48bca895ae75ee29ab7b639ad5462876241d350c2037bfd6bdb365423a3e.cfe-internal.js';
import { useLogicEditorContext } from './587a9c6736e7e443901f9bfa68401f276eb4b68d9d52fe6cf57f5f9d8d2114b6.cfe-internal.js';
import { LOGIC_TYPE_CONDITION } from './05a657b89c4e3b2985613913e27c531d51aad8696a81c63eaa65a9959b1f6913.cfe-internal.js';

var ConditionContainer = function ConditionContainer(_ref) {
  var _ref$condition = _ref.condition,
    condition = _ref$condition === void 0 ? {} : _ref$condition,
    position = _ref.position,
    firstFocusableElementRef = _ref.firstFocusableElementRef;
  var _useLogicEditorContex = useLogicEditorContext(),
    ConditionTemplate = _useLogicEditorContex.conditionTemplate,
    onConditionChange = _useLogicEditorContex.onConditionChange;
  var handleChange = function handleChange(value) {
    onConditionChange({
      id: condition.id,
      logicType: LOGIC_TYPE_CONDITION,
      value: value
    }, position);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.conditionContainer
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.condition
  }, /*#__PURE__*/React__default.createElement(ConditionTemplate, {
    value: condition.value,
    onChange: handleChange,
    firstFocusableElementRef: firstFocusableElementRef
  })));
};

export { ConditionContainer as default };
